import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";
import { useParams } from "react-router-dom";

function InvestorGuidanceAndBoardCommentary({
  investorGuidanceAndBoardCommentary,
}) {
  const [tabData, setTabData] = useState([]);
  const { clientName, competitorName } = useParams();
  const tableColumns = [
    { key: "growth_guidance", label: "Growth Guidance" },
    { key: "strategic_focus", label: "Strategic Focus" },
    {
      key: "capital_allocation_focus",
      label: "Capital Allocation Focus",
    },
    { key: "board_composition", label: "Board Composition" },
  ];

  // const dummyData = [
  //   {
  //     competitor: clientName ?? "HB Fuller",
  //     growth_guidance: "$8.05-$8.15 (FY25)",
  //     strategic_focus: "Specialty growth, GMPD efficiency",
  //     capital_allocation_focus: "Portfolio optimization, capital returns",
  //     board_composition:
  //       "11 members mix of former CEOs investors healthcare executives recently sunset Elliott-led review committee",
  //     growth_guidance_positive_insight: "$8.05-$8.15 (FY25)",
  //     growth_guidance_negative_insight: "$8.05-$8.15 (FY25)",
  //     growth_guidance_recent_development: "$8.05-$8.15 (FY25)",
  //     strategic_focus_positive_insight: "Specialty growth, GMPD efficiency",
  //     strategic_focus_negative_insight: "Specialty growth, GMPD efficiency",
  //     strategic_focus_recent_development: "Specialty growth, GMPD efficiency",
  //     capital_allocation_focus_positive_insight:
  //       "Portfolio optimization, capital returns",
  //     capital_allocation_focus_negative_insight:
  //       "Portfolio optimization, capital returns",
  //     capital_allocation_focus_recent_development:
  //       "Portfolio optimization, capital returns",
  //     board_composition_positive_insight:
  //       "11 members mix of former CEOs investors healthcare executives recently sunset Elliott-led review committee",
  //     board_composition_negative_insight:
  //       "11 members mix of former CEOs investors healthcare executives recently sunset Elliott-led review committee",
  //     board_composition_recent_development:
  //       "11 members mix of former CEOs investors healthcare executives recently sunset Elliott-led review committee",
  //   },
  //   {
  //     competitor: competitorName ?? "Tailored Chemical Products",
  //     growth_guidance: "Not Disclosed",
  //     strategic_focus: "Manufacturing expansion, IPO prep",
  //     capital_allocation_focus: "Growth investments",
  //     board_composition:
  //       "PE-backed board: Blackstone, Carlyle, H&F, GIC, Abu Dhabi; IPO-readiness structure emerging",
  //     growth_guidance_positive_insight: "$8.05-$8.15 (FY25)",
  //     growth_guidance_negative_insight: "$8.05-$8.15 (FY25)",
  //     growth_guidance_recent_development: "$8.05-$8.15 (FY25)",
  //     strategic_focus_positive_insight: "Specialty growth, GMPD efficiency",
  //     strategic_focus_negative_insight: "Specialty growth, GMPD efficiency",
  //     strategic_focus_recent_development: "Specialty growth, GMPD efficiency",
  //     capital_allocation_focus_positive_insight:
  //       "Portfolio optimization, capital returns",
  //     capital_allocation_focus_negative_insight:
  //       "Portfolio optimization, capital returns",
  //     capital_allocation_focus_recent_development:
  //       "Portfolio optimization, capital returns",
  //     board_composition_positive_insight:
  //       "11 members mix of former CEOs investors healthcare executives recently sunset Elliott-led review committee",
  //     board_composition_negative_insight:
  //       "11 members mix of former CEOs investors healthcare executives recently sunset Elliott-led review committee",
  //     board_composition_recent_development:
  //       "11 members mix of former CEOs investors healthcare executives recently sunset Elliott-led review committee",
  //   },
  //   {
  //     competitor: "AmerisourceBergen",
  //     growth_guidance: "$36.75–$37.25 (FY26)",
  //     strategic_focus: "Oncology & analytics platforms",
  //     capital_allocation_focus: "Divest Medical-Surgical, boost returns",
  //     board_composition:
  //       "Experienced board: includes ex-CEO of McDonald`s (Kevin Ozan), KPMG, ex-CDC Director (Dr. Julie Gerberding)",
  //     growth_guidance_positive_insight: "$8.05-$8.15 (FY25)",
  //     growth_guidance_negative_insight: "$8.05-$8.15 (FY25)",
  //     growth_guidance_recent_development: "$8.05-$8.15 (FY25)",
  //     strategic_focus_positive_insight: "Specialty growth, GMPD efficiency",
  //     strategic_focus_negative_insight: "Specialty growth, GMPD efficiency",
  //     strategic_focus_recent_development: "Specialty growth, GMPD efficiency",
  //     capital_allocation_focus_positive_insight:
  //       "Portfolio optimization, capital returns",
  //     capital_allocation_focus_negative_insight:
  //       "Portfolio optimization, capital returns",
  //     capital_allocation_focus_recent_development:
  //       "Portfolio optimization, capital returns",
  //     board_composition_positive_insight:
  //       "11 members mix of former CEOs investors healthcare executives recently sunset Elliott-led review committee",
  //     board_composition_negative_insight:
  //       "11 members mix of former CEOs investors healthcare executives recently sunset Elliott-led review committee",
  //     board_composition_recent_development:
  //       "11 members mix of former CEOs investors healthcare executives recently sunset Elliott-led review committee",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(
      investorGuidanceAndBoardCommentary
    );
    setTabData(tableData);
  }, [investorGuidanceAndBoardCommentary]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Investor Guidance & Board Commentary"
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default InvestorGuidanceAndBoardCommentary;
